import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CONSTANTS from '../../../constants';
import { pushEventToGTM } from '../../../helpers/trackerManager';

import {
	Link,
} from 'react-router-dom';

import SummarySectionBlock from "../summarySectionBlock";
import OperationItemSummary from "./operationItemSummary";
import EditButton from '../../buttons/EditButton';

import { CurrentStepSetAction, setSelectedPremiumServicesDsValetToStore, setSelectedPremiumServicesToStore, } from '../../../actions/action';

const mapStateToProps = state => state;
const mapDispatchToProps = { CurrentStepSetAction, setSelectedPremiumServicesDsValetToStore, setSelectedPremiumServicesToStore };

const OperationsSummary = (props) => {
	const { SelectedServices, personalInfos } = props.store;
	const [selectedPremiumServices, setSelectedPremiumServices] = useState(props.store.selectedPremiumServices || [])

	useEffect(() => {
		let selectedPsFiltred = []
		selectedPremiumServices.forEach(prService => {
			props.store.listPremiumServices.forEach(element => {
				if (prService.idServicePremium === element.idServicePremium) {
					selectedPsFiltred = [...selectedPsFiltred, element]
				};
			})
		}
		)
		setSelectedPremiumServices(selectedPsFiltred)
	}, [])

	return (
		<SummarySectionBlock
			fold={(window.isMobile() == 'desktop' ? false : true)}
			opened={(window.isMobile() == 'desktop' ? true : false)}
			title={CONSTANTS.LABELS.needs_basket_title}>
			<div className="operationsInfos-summary-block">
				<h3 tabIndex="0" className="block-title"><span className="block-titre">{CONSTANTS.LABELS.summary_operation_operationlist_intervention}</span>
					<span className="block-number">({SelectedServices.length})</span>
					<span className="block-description" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.summary_operation_operationlist_subtitle) }}></span>
				</h3>
				{!!props.store.booking.happy && <p className='happyHpour' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.email_happy_hour.replace('{{>Basket.Reduction}}', props.store.booking.happy)) }}></p>}
				<ul className="infos-list list-operations">
					{SelectedServices.map(function (forfait, fskey) {
						return (<li tabIndex="0" className="list-item" key={fskey}>
							<OperationItemSummary
								isForfait={(forfait.forfaits && !!forfait.forfaits.length)}
								forfait={forfait}

							/>
						</li>)
					})}


				</ul>
				{!!SelectedServices.length && !props.store.isEditMode && <Link to={CONSTANTS.SITE_ROUTS.SERVICESPAGE}
					onClick={(e) => {
						pushEventToGTM({
							pageName: 'summary',
							eventAction: 'Redirection::Internal::Modify',
							eventLabel: 'summary_modify_services'
						});
						props.CurrentStepSetAction(4);
					}}>
					<EditButton />

				</Link>}
				{!!SelectedServices.length && props.store.isEditMode && !props.expiredDate && <Link to={CONSTANTS.SITE_ROUTS.SERVICESPAGE}
					onClick={(e) => {
						pushEventToGTM({
							pageName: 'summary',
							eventAction: 'Redirection::Internal::Modify',
							eventLabel: 'summary_modify_services'
						});
						props.CurrentStepSetAction(4);
					}}>
					<EditButton />

				</Link>}
				{!!Object.values(selectedPremiumServices).length && <React.Fragment>
					<div className="premium-operations">
						<h3 className="block-title">
							<span dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.summary_premium_options) }}></span>
							<span className="block-number">({Object.values(selectedPremiumServices).length})</span>
						</h3>
						<ul className="infos-list list-operations">
							{Object.values(selectedPremiumServices).map((service, skey) => {
								return (
									<li className="list-item" key={skey}>
										<OperationItemSummary
											Service={service}
											isServicePremium={true} />
									</li>
								)

							})}


						</ul>
						{!props.store.isEditMode && <Link to={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE} onClick={(e) => {
							props.setSelectedPremiumServicesDsValetToStore([])
							const filtredServices = Object.values(props.store.selectedPremiumServices).filter(item => item.groupe !== 'dsValet');
							props.setSelectedPremiumServicesToStore(filtredServices);
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_services_premium'
							});
							props.CurrentStepSetAction(5);
						}}>
							<EditButton />
						</Link>}


						{props.store.isEditMode && !props.expiredDate &&
							<Link to={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
								onClick={(e) => {
									props.setSelectedPremiumServicesDsValetToStore([])
									const filtredServices = Object.values(props.store.selectedPremiumServices).filter(item => item.groupe !== 'dsValet');
									props.setSelectedPremiumServicesToStore(filtredServices);
									pushEventToGTM({
										pageName: 'summary',
										eventAction: 'Redirection::Internal::Modify',
										eventLabel: 'summary_modify_services_premium'
									});
									props.CurrentStepSetAction(5);
								}}>
								<EditButton />
							</Link>
						}
					</div>
				</React.Fragment>}
			</div>
		</SummarySectionBlock>

	)
}


export default connect(mapStateToProps, mapDispatchToProps)(OperationsSummary);
